var csrf_token,
  liveLocalTestingForm = {};

liveLocalTestingForm.formObj = document.getElementById("live-local-testing-form");
liveLocalTestingForm.urlField = document.getElementById("live-local-testing-url");
liveLocalTestingForm.submitBtn = document.getElementById("live-local-testing-submit-btn");

window.addEventListener("load", function() {
  var formElemHeight = liveLocalTestingForm.formObj ? liveLocalTestingForm.formObj.offsetHeight : 0;

  // load recaptcha JS after page load
  if (formElemHeight) {
    document.addEventListener("click", fnLoadUserToken);
  }

  function fnLoadUserToken() {
    // Ajax call for csrf_token
    if (!csrf_token) {
      bsLib.ajax(
        'GET',
        bsLib.railsHost() + '/user/token.json',
        {},
        true,
        {},
        // Success message for user token.
        function (data) {
          if (data.readyState === 4) {
            var dataRequest = bsLib.JSONParse(data.response);
            csrf_token = dataRequest.csrf_token;
          }
        },
        // Custom Error message for user token.
        function () {
          return Messages.salesAndSupportPage.invalidUserToken;
        }
      );
    }
  }
});

var urlLocalTestingForm = (function(liveLocalTestingForm) {
  return {
    validateFields: _validateFields
  };

  function _validateFields() {
    var formValid = true,
      url = liveLocalTestingForm.urlField.value,
      urlError = document.getElementById("live-url-error"),
      urlValidation = validURL(liveLocalTestingForm.urlField.value);
      
    if (liveLocalTestingForm.urlField.value.trim().length === 0 || urlValidation.isInvalid) {
      formValid = _showError(
        liveLocalTestingForm.urlField,
        urlError,
        "live-url-error",
        urlValidation.errorMessage
      );
    } else {
      liveLocalTestingForm.urlField.classList.remove("error-border");
      liveLocalTestingForm.urlField.removeAttribute('aria-describedby');
      if (urlError) {
        urlError.remove();
      }
    }

    if (formValid) {
      liveLocalTestingForm.submitBtn.setAttribute("disabled", "disabled");
      liveLocalTestingForm.submitBtn.value = liveLocalTestingForm.submitBtn.dataset.btndisabled;

      // on successful submit event
      WebEventTracker.logEvent(EDS.webEvents, "InteractedWithLiveMarketingPage", {
        action: "Clicked Test Now",
        userToken: csrf_token,
        enteredURL: liveLocalTestingForm.urlField.value,
        localDiscoveryLiveHomepageExperimentVariation: "yes"
      });

      bsLib.ajax(
        "POST",
        bsLib.railsHost() + "/wp-admin/admin-ajax.php",
        {
          action: "bstack_check_valid_url",
          security: ajax_initialize_script.ajax_nonce, // nonce
          url: url
        },
        true, //async
        {
          "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
        }, //request header
        function(data) {
          var dataRequest = bsLib.JSONParse(data.response);
          if (data.readyState === 4 && dataRequest) {
            var URLTypeEntered;
            liveLocalTestingForm.submitBtn.removeAttribute("disabled");
            liveLocalTestingForm.submitBtn.value = liveLocalTestingForm.submitBtn.dataset.btntext;

            if (dataRequest.status) {
              URLTypeEntered = 'public';
            } else { 
              var privateFieldCount = liveLocalTestingForm.submitBtn.parentNode.getElementsByClassName('hidden-private-field').length; 
              if (privateFieldCount === 0) {
                liveLocalTestingForm.submitBtn.insertAdjacentHTML('afterend', '<input class="hidden-private-field" name="private" type="hidden" value="true"/>');
              }
              URLTypeEntered = 'private';    //for status 0, consider it private url
            }
  
            liveLocalTestingForm.formObj.dataset.validated = 1;
            liveLocalTestingForm.formObj.submit();
          }
        }, //success
        function() {} //error object
      );
    }

    return formValid;
  }

  function validURL(str) {
    var pattern = /(^\s+)|(\s+)|(\s+$)/g; // check whitespace in the URL string
    return {
      isInvalid: pattern.test(str),
      errorMessage: "Invalid URL"
    };
  }

  function _showError(fieldName, fieldError, errorName, errorMessage) {
    inlineError.showError(fieldName, fieldError, errorName, errorMessage);
    fieldName.setAttribute('aria-describedby', errorName);

    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithLiveMarketingPage", {
      action: errorName,
      message: errorMessage,
      InvalidInput: true
    });
  }
})(liveLocalTestingForm);

if (liveLocalTestingForm.urlField) {
  //blur event
  liveLocalTestingForm.urlField.addEventListener("blur", function(e) {
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithLiveMarketingPage", {
      action: "Entered URL",
      userToken: csrf_token,
      localDiscoveryLiveHomepageExperimentVariation: "yes"
    });
  });
}

if (liveLocalTestingForm.formObj) {
  liveLocalTestingForm.formObj.addEventListener("submit", function(e) {
    e.preventDefault();
    
    if (liveLocalTestingForm.formObj.dataset.validated === "1") {
      return true;
    }

    return urlLocalTestingForm.validateFields();
  });
}